export const fieldNames = {
  master: 'master',
};
